/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	ExportIntegrationDeletePathParams,
	ExportIntegrationDeleteResponse,
} from '../types/ExportIntegrationDelete'

/**
 * DELETE /export-integrations/:integration
 * @see backend/nexus/modules/ExportIntegrations/Http/Controllers/ExportIntegrationController.php ExportIntegrationController::delete
 */
export async function exportIntegrationDelete(
	integration: ExportIntegrationDeletePathParams['integration'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ExportIntegrationDeleteResponse>> {
	return axiosInstance.delete(`/export-integrations/${integration}`, config)
}
